var _style, _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _g6, _circle7, _g7, _circle8, _g8, _circle9, _g9, _circle10, _g10, _circle11, _g11, _circle12, _g12, _circle13, _g13, _circle14, _g14, _circle15, _g15, _circle16, _g16, _rect, _path3, _g17, _rect2, _path4, _g18, _rect3, _path5, _g19, _rect4, _path6, _g20, _rect5, _path7, _g21, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 158",
    style: {
      enableBackground: "new 0 0 210 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#585E65;}\n\t.st1{fill:#9E9FA3;}\n\t.st2{fill:#08161F;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#9FA0A4;}\n\t.st5{fill:#E5E5E5;}\n\t.st6{fill:#C70502;}\n\t.st7{fill:#ECECEC;}\n\t.st8{fill:#323232;}\n\t.st9{fill:#FAFAFA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,70.7c-1.7,0-3.4-0.7-4.7-2c-1.7-1.7-3-8.1-4.3-15.7c-0.5-2.5-0.8-4.7-1.1-5.7l1.3-0.4 c0.3,1.1,0.7,3.2,1.2,5.8c1,5.3,2.4,13.4,3.9,15c1.4,1.4,3.3,1.9,5.1,1.4c1.7-0.5,3-1.8,3.4-3.2c0.7-2.9,1.1-9.6,1.1-19.8v-0.3h1.4 v0.3c0,3.8,0,15.5-1.1,20.1c-0.5,2-2.2,3.6-4.3,4.2C54.4,70.6,53.8,70.7,53.2,70.7L53.2,70.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,146.4c-4.7,0-8.9-4-9.4-8.9c-0.7-7.2,4.4-9.9,8.6-12.1c0.7-0.3,1.3-0.7,1.9-1c6-3.4,10.5-6,15.1-8.7 c2.5-1.5,4.2-4.3,4.2-7c0-2.8-1.7-5.2-4.9-7c-2.6-1.5-5.4-2.8-8.2-4.1c-3.7-1.8-7.2-3.4-9.8-5.3c-2.1-1.5-4.3-3.3-5.5-7l-8.1-23.6 l-6.5-18.8c-0.1-0.3-1-2.7-1.1-5.4c-0.2-4,1.2-6.9,4.2-8.3c6.2-2.9,13.5-4.9,14.1-5.1c0.4-0.1,3.7-1.1,6.8,0.4c2,1,3.4,2.7,4.2,5.2 c2.5,7.4,8.6,27.4,8.7,27.5l0,0c0.3,1.2,1.5,4.3,3.6,4.7c1.4,0.3,2.5,0.2,3.2-0.4c1-0.7,1.6-2.2,1.9-4.5c0.6-4.5,3.7-28.5,4.7-35.7 c0-0.2,0.2-1.3,0.3-2.8l0,0c0.7-5.9,4.1-9.2,9.4-9.3h0.1c6.5,0,9.3,5.7,10,9.1c1.3,6.8,3.5,12.4,5.9,15.5c2.7,3.4,5.3,5.6,7.3,7.3 c3.3,2.8,5.7,4.8,5.5,9.5c-0.1,1.6-1.2,5.4-2.5,9.8c-0.2,0.8-0.5,1.6-0.7,2.2c-0.4,1.6-0.8,2.6-1,3.5c-0.4,1.4-0.6,2.2-1,3.6 c-1.3,4.7-0.8,7.4,1.5,9.1c2.2,1.6,5.2,0.9,7.4,0.4l0.4-0.1c5.7-1.4,10.9-3.7,15.4-6.8c7-4.9,12.4-11.8,16.1-20.7 c2-4.7,4.1-10.2,5.9-15c2.5-6.6,4.5-11.8,5.7-13.7c2.7-4.5,6.8-7.1,11.1-7.2c6.9-0.1,8.7-0.1,11-0.1c1.2,0,2.5,0,4.8,0 c4.1,0,7.3,2,9.3,5.8c1.3,2.6,4.8,8.7,7.3,13.1c0.8,1.5,1.6,2.8,2.1,3.7c1.4,2.4,1.7,5.3,0.9,7.9c-0.8,2.6-6,8.7-7.1,9.8 c-5.5,6.2-15.1,18.1-17.9,21.6c-1.5,1.8-2,4.2-1.5,6.4c0.3,1.2,0.8,2.5,1.6,3.7c1.4,2.1,4.1,6.1,7.1,10.8 c7.1,10.8,16.9,25.7,20,29.9c2.3,3.1,2.9,4.9,3.1,6.9c0.2,1.6,0.2,4.5-2.1,7c-2.1,2.4-5.7,3.6-10.6,3.6c-0.1,0-0.3,0-0.4,0 c-3,0-10.7,0-20.5,0c-4.8,0-10.1,0-15.7,0c-8,0-23.5,0-37.2,0.1H98.1c-8,0-12,0-13.2,0c-17.9,0-33.9,0-43.4,0 C38.3,146.4,35.7,146.4,33.9,146.4L33.9,146.4z M31.5,25.8c-1.4,0-2.4,0.3-2.4,0.4H29c-0.1,0-7.6,2.1-13.8,5 c-5.4,2.5-2.1,11.2-2.1,11.2l0,0l6.6,18.8L28,84.8c1,3.1,2.7,4.6,4.7,6c2.5,1.8,5.9,3.4,9.5,5.1c2.8,1.3,5.6,2.7,8.3,4.2 c3.8,2.1,5.8,5.2,5.9,8.7c0,3.4-2.1,6.9-5.2,8.7c-4.6,2.7-9.1,5.3-15.1,8.7c-0.6,0.4-1.3,0.7-2,1.1c-4.2,2.2-8.1,4.2-7.5,10.1 c0.4,3.9,3.7,7.1,7.4,7.1c1.8,0,4.5,0,7.8,0c9.5,0,25.5,0,43.4,0c1.2,0,5.2,0,13.2,0h14.5c13.7,0,29.2-0.1,37.2-0.1 c5.6,0,10.9,0,15.7,0c9.8,0,17.5,0,20.5,0c4.5,0.1,7.7-0.9,9.5-3c1.7-1.9,1.7-4.2,1.6-5.5c-0.2-1.5-0.5-2.9-2.7-6 c-3.1-4.3-12.9-19.1-20.1-30c-3.1-4.7-5.8-8.7-7.1-10.8c-0.9-1.4-1.6-2.9-1.9-4.3c-0.6-2.8,0.1-5.8,1.9-8.1 c2.8-3.5,12.4-15.4,18-21.7c2.9-3.2,6.2-7.5,6.7-9.1c0.6-2.1,0.4-4.5-0.8-6.4c-0.5-0.9-1.3-2.2-2.1-3.7c-2.5-4.5-6-10.6-7.3-13.2 c-1.6-3.1-4.2-4.8-7.5-4.8c-2.2,0-3.6,0-4.8,0c-2.3,0-4.1,0-11,0.1c-3.6,0.1-7.1,2.4-9.4,6.3c-1.1,1.8-3.1,7.2-5.5,13.4 c-1.8,4.8-3.9,10.3-5.9,15c-3.9,9.2-9.5,16.4-16.8,21.5c-4.7,3.3-10.2,5.7-16.1,7.1l-0.4,0.1c-2.4,0.6-6.1,1.5-9.1-0.7 c-3.8-2.8-3.3-7.2-2.2-11.2c0.4-1.5,0.6-2.3,1-3.7c0.2-0.8,0.6-1.9,1-3.5c0.2-0.6,0.4-1.4,0.7-2.2c0.9-3.1,2.3-7.8,2.4-9.3 c0.2-3.8-1.6-5.3-4.8-8c-2.1-1.8-4.7-4-7.6-7.6c-2.7-3.3-5-9.3-6.3-16.4c-0.1-0.3-1.6-7.5-8.2-7.5c-5.4,0.1-7.1,4.1-7.5,7.5l0,0 c-0.2,1.6-0.3,2.6-0.3,2.8c-0.9,7.2-4.1,31.2-4.7,35.7c-0.4,2.9-1.3,4.8-2.7,5.8c-1.2,0.9-2.8,1.1-4.7,0.7c-3.6-0.7-5-5.7-5.1-6.2 c-0.2-0.8-6.2-20.2-8.6-27.5c-0.7-2-1.7-3.4-3.2-4.1C33.4,25.9,32.4,25.8,31.5,25.8L31.5,25.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 19.8,
    cy: 141.3,
    r: 3.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.8,142.4h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7H21v0.5h-2.1v-0.5H18.8z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 48.6,
    cy: 109.9,
    r: 3.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.5,110.9c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.6,0,1.1,0.3,1.1,0.9v0.1c0,0.6-0.2,0.8-0.7,1l-0.4,0.1c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5 h-2.1v-0.7H47.5z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 24.5,
    cy: 93.4,
    r: 3.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.4,94.9l0.1-0.5c0.2,0.1,0.5,0.2,0.9,0.2s0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5H24v-0.5h0.3 c0.4,0,0.6-0.1,0.6-0.4l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2L23.4,92c0.2-0.1,0.6-0.2,1.1-0.2c0.6,0,1.1,0.2,1.1,0.8v0.1 c0,0.3-0.2,0.6-0.5,0.7l0,0c0.3,0.1,0.5,0.3,0.5,0.7v0.1c0,0.7-0.4,1-1.2,1C24,95.1,23.6,95,23.4,94.9z"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5.9,
    cy: 30.9,
    r: 3.4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.2,31.8H4.6v-0.4l1.1-2.2h0.7l-1.1,2.1h0.8v-0.9h0.7v0.9h0.4v0.5H6.9v0.6H6.2V31.8z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 39.8,
    cy: 21,
    r: 3.4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41,21.6L41,21.6c0,0.8-0.4,1.1-1.2,1.1c-0.5,0-0.9-0.1-1.1-0.3l0.2-0.5c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5c-0.2,0-0.5,0-0.7,0L38.9,21l0.1-1.6h1.8v0.5h-1.2l-0.1,0.7c0.1,0,0.2,0,0.3,0 C40.6,20.6,41,20.8,41,21.6z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 52.2,
    cy: 51.9,
    r: 3.4
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53.4,52.4L53.4,52.4c0,0.7-0.4,1.1-1.1,1.1c-0.9,0-1.2-0.5-1.2-1.5v-0.1c0-1.3,0.5-1.7,1.3-1.7 c0.3,0,0.6,0.1,0.8,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.6,0.1-0.7,0.7c0.2,0,0.4,0,0.6,0C53,51.5,53.4,51.7,53.4,52.4z  M52.7,52.5c0-0.4-0.1-0.5-0.5-0.5c-0.2,0-0.3,0-0.5,0c0,0.7,0.1,1,0.5,1C52.6,53,52.7,52.8,52.7,52.5L52.7,52.5z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 72.2,
    cy: 4.1,
    r: 3.4
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.6,3H71V2.5h2.3V3L72,5.8h-0.7L72.6,3z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 91.4,
    cy: 30.3,
    r: 3.4
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.6,31L92.6,31c0,0.6-0.4,1-1.2,1c-0.8,0-1.2-0.3-1.2-0.9l0,0c0-0.4,0.2-0.6,0.4-0.8 c-0.2-0.1-0.4-0.4-0.4-0.7l0,0c0-0.6,0.4-0.9,1.1-0.9s1.1,0.3,1.1,0.9l0,0c0,0.3-0.1,0.6-0.4,0.7C92.5,30.4,92.6,30.6,92.6,31z  M91.9,31c0-0.3-0.1-0.5-0.5-0.5l0,0c-0.3,0-0.5,0.1-0.5,0.5l0,0c0,0.3,0.1,0.5,0.5,0.5S91.9,31.3,91.9,31L91.9,31z M91,29.6 c0,0.3,0.1,0.4,0.4,0.4l0,0c0.3,0,0.4-0.2,0.4-0.4l0,0c0-0.3-0.1-0.4-0.4-0.4S91,29.3,91,29.6L91,29.6z"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.4,
    cy: 47.7,
    r: 3.4
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.6,47.3v0.6c0,0.9-0.2,1.4-1.2,1.4c-0.4,0-0.7,0-0.9-0.1l0.1-0.6c0.2,0.1,0.5,0.1,0.8,0.1 c0.4,0,0.6-0.2,0.6-0.7c-0.2,0-0.4,0-0.5,0c-0.8,0-1.1-0.3-1.1-1l0,0c0-0.7,0.4-1,1.1-1C106.3,46,106.6,46.4,106.6,47.3z  M105.5,47.6c0.2,0,0.3,0,0.5,0v-0.1c0-0.7,0-0.9-0.5-0.9c-0.4,0-0.5,0.2-0.5,0.5l0,0C105,47.4,105.1,47.6,105.5,47.6z"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 99.7,
    cy: 74.6,
    r: 3.4
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.4,75.7h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1v-0.5H97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.2,76c-0.2-0.2-0.3-0.6-0.3-1.3v-0.1c0-0.7,0.1-1.1,0.3-1.3c0.2-0.2,0.5-0.3,0.9-0.3 c0.5,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.6,0.3,1.3v0.1c0,0.8-0.1,1.1-0.3,1.3c-0.2,0.2-0.5,0.3-0.9,0.3 C100.7,76.2,100.4,76.2,100.2,76z M101.5,75.6c0.1-0.2,0.1-0.5,0.1-1v-0.1c0-0.5,0-0.8-0.1-1c-0.1-0.1-0.2-0.1-0.4-0.1 c-0.2,0-0.3,0-0.4,0.1c-0.1,0.2-0.1,0.4-0.1,0.9v0.1c0,0.5,0,0.8,0.1,0.9s0.2,0.2,0.4,0.2C101.3,75.7,101.4,75.7,101.5,75.6z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 120.4,
    cy: 65.1,
    r: 3.4
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.1,66.2h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1v-0.5H118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.8,66.2h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1v-0.5H120.8z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 146.6,
    cy: 15.6,
    r: 3.4
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144.3,16.7h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1L144.3,16.7L144.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.9,16.6c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.6,0,1.1,0.3,1.1,0.9V15c0,0.6-0.2,0.8-0.7,1H148c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5h-2.1 V16.6z"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 181.9,
    cy: 12.2,
    r: 3.4
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.6,13.3h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1L179.6,13.3L179.6,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.1,13.6l0.1-0.5c0.2,0.1,0.5,0.2,0.9,0.2s0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5h-0.4v-0.5h0.3 c0.4,0,0.6-0.1,0.6-0.4l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2l-0.2-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.6,0,1.1,0.2,1.1,0.8v0.1 c0,0.3-0.2,0.6-0.5,0.7l0,0c0.3,0.1,0.5,0.3,0.5,0.7v0.1c0,0.7-0.4,1-1.2,1C182.7,13.8,182.4,13.8,182.1,13.6z"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 199.8,
    cy: 44.2,
    r: 3.4
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.5,45.3h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1L197.5,45.3L197.5,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.5,45.2h-1.6v-0.4l1.1-2.2h0.7l-1.1,2.1h0.8v-0.9h0.7v0.9h0.4v0.5h-0.4v0.6h-0.7v-0.6H201.5z"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 172.6,
    cy: 82.8,
    r: 3.4
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.3,83.8h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1L170.3,83.8L170.3,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.2,83.3L175.2,83.3c0,0.8-0.4,1.1-1.2,1.1c-0.5,0-0.9-0.1-1.1-0.3l0.2-0.5c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5c-0.2,0-0.5,0-0.7,0l-0.1-0.2l0.1-1.6h1.8v0.5h-1.2l-0.1,0.7c0.1,0,0.2,0,0.3,0 C174.8,82.3,175.2,82.6,175.2,83.3z"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 204.1,
    cy: 141.5,
    r: 3.4
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.8,142.6h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.7h0.7v0.5h-2.1L201.8,142.6L201.8,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206.7,142.1L206.7,142.1c0,0.7-0.4,1.1-1.1,1.1c-0.9,0-1.2-0.5-1.2-1.5v-0.1c0-1.3,0.5-1.7,1.3-1.7 c0.3,0,0.6,0.1,0.8,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.6,0.1-0.7,0.7c0.2,0,0.4,0,0.6,0 C206.3,141.1,206.7,141.3,206.7,142.1z M206,142.1c0-0.4-0.1-0.5-0.5-0.5c-0.2,0-0.3,0-0.5,0c0,0.7,0.1,1,0.5,1 C205.9,142.7,206,142.5,206,142.1L206,142.1z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.8,
    y: 142.4,
    className: "st5",
    width: 0.7,
    height: 9.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.3,149.7H94v7.6h8.3V149.7z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.5,152c0-0.6,0.3-0.8,0.9-0.8h2v0.8h-1.7c-0.1,0-0.2,0.1-0.2,0.2v0.9h1.8v0.8h-1.8v1.9h-1 C95.5,155.8,95.5,152,95.5,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M99.3,155v-3.9h1v3.7c0,0.1,0,0.1,0.1,0.1h1.4v0.8H100C99.5,155.7,99.3,155.5,99.3,155z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 66.8,
    transform: "matrix(0.9515 -0.3075 0.3075 0.9515 -19.7222 9.1314)",
    className: "st7",
    width: 9.4,
    height: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.5,64.9H8.2l0,0v7.6h8.3V64.9z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.1,66.1h1V67h-1V66.1z M10.1,67.5H11V71h-0.9V67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.2,70.2h1.1v-2.9l0,0l-1,0.3l-0.2-0.8l1.3-0.4h0.8v3.8h0.9V71h-3L12.2,70.2L12.2,70.2z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179.6,
    y: 21.4,
    transform: "matrix(0.866 -0.5 0.5 0.866 13.7961 95.0283)",
    className: "st7",
    width: 9.2,
    height: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.1,15.6h-8.3l0,0v7.6h8.3V15.6z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M188.7,16.8h1v0.9h-1V16.8z M188.7,18.2h0.9v3.5h-0.9V18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.5,21.4l0.1-0.8c0.3,0.2,0.8,0.3,1.3,0.3c0.6,0,0.8-0.2,0.8-0.6v-0.1c0-0.5-0.3-0.6-0.8-0.6h-0.6v-0.8h0.4 c0.6,0,0.8-0.1,0.8-0.6l0,0c0-0.4-0.3-0.5-0.7-0.5c-0.5,0-0.8,0.1-1.1,0.3l-0.2-0.8c0.3-0.2,0.9-0.3,1.5-0.3c0.8,0,1.5,0.3,1.5,1.2 v0.1c0,0.5-0.2,0.8-0.6,1l0,0c0.4,0.1,0.8,0.4,0.8,1.1v0.1c0,1-0.6,1.4-1.7,1.4C191.4,21.7,190.9,21.6,190.5,21.4z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7,
    y: 19.4,
    transform: "matrix(0.9553 -0.2957 0.2957 0.9553 -2.1792 25.1007)",
    className: "st7",
    width: 8.4,
    height: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.2,14.8H85l0,0v7.6h8.3v-7.6H93.2z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M86.9,16h1v0.9h-1V16z M86.9,17.3h0.9v3.5h-0.9V17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.8,20c0-1,0.3-1.4,1-1.6l0.5-0.1c0.4-0.1,0.5-0.2,0.5-0.7l0,0c0-0.4-0.3-0.6-0.7-0.6 c-0.5,0-0.9,0.1-1.2,0.3l-0.2-0.7c0.3-0.2,0.9-0.3,1.5-0.3c0.9,0,1.6,0.4,1.6,1.3v0.1c0,0.8-0.2,1.1-1,1.3l-0.5,0.2 c-0.5,0.1-0.6,0.4-0.6,0.7v0.2h2.1v0.8h-3C88.8,20.9,88.8,20,88.8,20z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 142.3,
    className: "st7",
    width: 0.7,
    height: 9.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.1,149.6h-5.8l0,0v6.3h5.8V149.6L77.1,149.6z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73,154.5l0.2-0.6c0.3,0.1,0.7,0.2,1,0.2c0.5,0,0.7-0.1,0.7-0.5l0,0c0-0.3-0.1-0.4-0.4-0.5L74,153 c-0.7-0.2-1-0.4-1-1.1v-0.1c0-0.8,0.5-1.1,1.3-1.1c0.4,0,0.9,0.1,1.1,0.2l-0.2,0.6c-0.3-0.1-0.7-0.2-0.9-0.2c-0.4,0-0.6,0-0.6,0.4 l0,0c0,0.3,0.1,0.4,0.5,0.4l0.4,0.1c0.7,0.1,0.9,0.4,0.9,1.1v0.1c0,0.9-0.5,1.2-1.4,1.2C73.8,154.7,73.2,154.6,73,154.5z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 152.2,
    className: "st9",
    width: 0.8,
    height: 5.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 153.1,
    width: 0.8,
    height: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 154.7,
    width: 0.8,
    height: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 156.4,
    width: 0.8,
    height: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 152.2,
    className: "st9",
    width: 0.8,
    height: 5.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 152.2,
    width: 0.8,
    height: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 153.9,
    width: 0.8,
    height: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 155.6,
    width: 0.8,
    height: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 149.7,
    className: "st9",
    width: 0.8,
    height: 2.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 149.7,
    width: 0.8,
    height: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 151.4,
    width: 0.8,
    height: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 149.7,
    className: "st9",
    width: 0.8,
    height: 2.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 150.5,
    width: 0.8,
    height: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/qatar.0aea71c50ae96c3f5238e45479deacbf.svg";
export { ForwardRef as ReactComponent };